import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GoogleLogin, CredentialResponse } from '@react-oauth/google';
import { useAuth } from '../contexts/AuthContext';
import './Login.css';

const Login: React.FC = () => {
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { googleLogin } = useAuth();
  const navigate = useNavigate();

  const handleGoogleSuccess = async (credentialResponse: CredentialResponse) => {
    if (!credentialResponse.credential) {
      setError('Google 인증 정보를 받지 못했습니다.');
      return;
    }

    setError('');
    setIsLoading(true);

    try {
      const result = await googleLogin(credentialResponse.credential);

      if (result.needsRegistration && result.googleProfile) {
        navigate('/register', {
          state: {
            googleProfile: result.googleProfile,
            idToken: credentialResponse.credential,
          },
        });
      } else if (result.access_token) {
        navigate('/dashboard');
      }
    } catch (err: any) {
      setError(err.response?.data?.message || 'Google 로그인에 실패했습니다.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleGoogleError = () => {
    setError('Google 로그인에 실패했습니다. 다시 시도해주세요.');
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h2>시큐센터 (Security Center)</h2>
        <p className="login-description">
          vntgcorp.com, seah.co.kr, ctckorea.com, irongrey.co, dongasteel.co.kr 계정으로 로그인하세요.
        </p>

        {error && <div className="error-message">{error}</div>}

        <div className="google-login-wrapper">
          {isLoading ? (
            <div className="loading-text">로그인 중...</div>
          ) : (
            <GoogleLogin
              onSuccess={handleGoogleSuccess}
              onError={handleGoogleError}
              size="large"
              width="320"
              text="signin_with"
              shape="rectangular"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;
